export const BASE_URL = `https://api.bergregions.pl/api/v1/ski-info/45904333/stations/5fd38137a539d93aea576f54/weather`;
